import React from 'react';
import RegularDownloadTicketsModal from '../../checkout/DownloadTicketsModal';

class DownloadTicketsModal extends RegularDownloadTicketsModal {

    _getFareName(fare) {
        return <span className="text-weight--normal no-margin">{ fare.getName() }</span>;
    }
}

export default DownloadTicketsModal;



// WEBPACK FOOTER //
// ./src/components/roversRangers/checkout/DownloadTicketsModal.js